import React from "react";
import Banner from "./Banner";

const Homepage = () => {
  return (
    <>
      <Banner />
    </>
  );
};

export default Homepage;
